import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '../../../lib/utils';
/**
 * Specra Badge — soft status pill (3px radius, tinted bg + colored text +
 * hairline border). Pair with StatusBadge when you want the leading dot.
 *
 */ const specraBadgeVariants = cva('inline-flex items-center gap-[var(--space-1-5)] whitespace-nowrap rounded-[var(--radius-sm)] border px-[var(--space-2)] py-[var(--space-1)] text-[length:var(--fs-ui-caption)] font-medium leading-none', {
    variants: {
        variant: {
            default: 'border-transparent bg-primary text-primary-foreground',
            dark: 'border-transparent bg-primary text-primary-foreground',
            secondary: 'border-transparent bg-secondary text-secondary-foreground',
            destructive: 'border-transparent bg-danger text-danger-foreground',
            outline: 'border-border bg-transparent text-foreground',
            neutral: 'border-border bg-muted text-muted-foreground',
            success: 'border-success/20 bg-success-muted text-success',
            green: 'border-success/20 bg-success-muted text-success',
            warning: 'border-warning/25 bg-warning-muted text-warning',
            yellow: 'border-warning/25 bg-warning-muted text-warning',
            danger: 'border-danger/25 bg-danger-muted text-danger',
            red: 'border-danger/25 bg-danger-muted text-danger',
            info: 'border-brand/20 bg-brand-muted text-brand',
            blue: 'border-brand/20 bg-brand-muted text-brand',
            /** Routed / escalated / corrected: the fifth status hue (D115). */ violet: 'border-violet/20 bg-violet-muted text-violet',
            /** High severity: between warning (Moderate) and danger (Blocking). */ orange: 'border-orange/25 bg-orange-muted text-orange',
            /** Delivery plane (Growth redesign D3, OD-09): teal, between success and info. */ teal: 'border-teal/20 bg-teal-muted text-teal',
            'solid-success': 'border-transparent bg-success text-success-foreground',
            'solid-danger': 'border-transparent bg-danger text-danger-foreground'
        }
    },
    defaultVariants: {
        variant: 'neutral'
    }
});
const SpecraBadge = /*#__PURE__*/ React.forwardRef(({ className, variant, ...props }, ref)=>/*#__PURE__*/ _jsx("span", {
        className: cn(specraBadgeVariants({
            variant
        }), className),
        ref: ref,
        ...props
    }));
SpecraBadge.displayName = 'SpecraBadge';
export { SpecraBadge, specraBadgeVariants };
